import { View } from './View.js';

class WorksheetView extends View {
	_parentElement = document.querySelector('.worksheet-content');

	_generateMarkUp() {
		this._parentElement = document.querySelector('.worksheet-content');

		return `<div class="letter-box">
        <img
            id="img-name"
            src="${this._pageData.imgfilename}"
            class="letter-box__img"
            alt="حرف ج"
        />
    </div>

    <div class="worksheet-details">
        <p class="worksheet-description">
        ${this._pageData.description ? this._pageData.description : ''} 
        </p>
        <a
            id="file-name"
            class="worksheet-print"
            href="${this._pageData.pdffilename}" 
            target="_blank"
            >طباعة</a
        >
        <p class="worksheet-level-label">المستوى :</p>
        <a
            id="file-name"
            class="worksheet-level"
            target="_blank"
            >مبتدئ</a
        >
    </div>
    `;
	}
}

export default new WorksheetView();
